// extracted by mini-css-extract-plugin
export default {"states-container":"Agent_states-container__BTMTX","fixed-columns":"Agent_fixed-columns__KKgOf"};